import {
  TranscriptionNoRealtimeProviderName,
  TranscriptionProviderName,
} from "@/hooks/transcriber/types";
import type { TranscriptionProviderOption } from "@/common/types/types";
import { AppConfig } from "./appConfig";

export const MAX_AUDIO_MB = 25;
export const ALLOWED_AUDIO_MIME_TYPES = [
  "audio/mpeg", // .mp3
  "audio/x-m4a", // .m4a
  "audio/wav", // .wav
  // "audio/ogg", // .ogg
  // "video/mp4", // .mp4
  // "audio/mp4", // .m4a
  // "audio/webm", // .webm
  // "video/webm", // .webm
];
export const REFRESH_AUDIO_INTERVAL = 2000;

export const AUDIO_TRANSCRIPTION_NO_REALTIME_PROVIDERS: TranscriptionProviderOption[] =
  [
    {
      label: "Deepgram",
      value: TranscriptionNoRealtimeProviderName.DEEPGRAM_NOVA_3_MEDICAL,
    },
  ].filter((p) =>
    AppConfig.transcriptionsProvidersNoRealtime.includes(p.value)
  );

export const AUDIO_TRANSCRIPTION_REALTIME_PROVIDERS: TranscriptionProviderOption[] =
  [
    {
      label: "OpenAI",
      value: TranscriptionProviderName.OPENAI,
    },
    {
      label: "Speechmatic",
      value: TranscriptionProviderName.SPEECHMATIC,
    },
    {
      label: "Deepgram",
      value: TranscriptionProviderName.DEEPGRAM,
    },
  ].filter((p) => AppConfig.transcriptionsProvidersRealtime.includes(p.value));
